import type { UserContextType } from '@/client/context/user'
import getLocalStorage from '@/client/services/browserStorage/getLocalStorage'

import type { NavbarBannerType } from '../types'
import BannerComponent from './BannerComponent'

// This is a wrapper around <BannerComponent> that handles determining
// whether it has been dismissed or not.
export default function getBannerComponent({
  user,
  banner,
  currentUrl,
  setShowBanner,
}: {
  user: UserContextType
  banner: NavbarBannerType
  currentUrl: string
  setShowBanner: (show: boolean) => void
}): JSX.Element | null {
  const bannerStorageKey = `user:${user.id}-banner:${banner.slug}-dismissed`

  const bannerDismissalLocalStorage = getLocalStorage(bannerStorageKey)
  const isDismissed = bannerDismissalLocalStorage.get() === 'true'

  if (isDismissed || (banner.link != null && currentUrl === banner.link)) {
    return null
  }

  return (
    <BannerComponent
      banner={banner}
      onDismiss={() => {
        setShowBanner(false)
        bannerDismissalLocalStorage.set('true')
      }}
    />
  )
}
